module.exports = __webpack_public_path__ + "assets/img/33_1572_big.9f9825ae.jpg";